import React, { memo } from 'react';

import { TableCell as MuiCell } from '@mui/material';
import PropTypes from 'prop-types';

import { mediaQuery, TABLE_CELL_ALIGNMENT } from 'constants/ui';

export const getCellStyles = (isLargeContent, customStyles) => ({
  height: '48px',
  padding: '0 15px',
  minWidth: '100px',

  ...(isLargeContent && {
    width: '405px',
  }),

  '&.hidden': {
    width: 0,
    padding: '0 !important',
    margin: '0 !important',
    visibility: 'hidden',
  },

  [mediaQuery.mobile]: {
    minWidth: '72px',

    ...(isLargeContent && {
      width: 'auto',
    }),
  },

  ...customStyles,
});

const TableCell = ({
  children,
  align = TABLE_CELL_ALIGNMENT.LEFT,
  dataLabel,
  dataTestId,
  isLargeContent = false,
  customStyles,
}) => {
  const cellStyles = getCellStyles(isLargeContent, customStyles);

  return (
    <MuiCell
      align={align}
      data-label={dataLabel}
      data-testid={dataTestId}
      scope="row"
      sx={cellStyles}
    >
      {children}
    </MuiCell>
  );
};

TableCell.propTypes = {
  children: PropTypes.node.isRequired,
  align: PropTypes.oneOf(Object.values(TABLE_CELL_ALIGNMENT)),
  dataLabel: PropTypes.string,
  dataTestId: PropTypes.string,
  isLargeContent: PropTypes.bool,
  customStyles: PropTypes.object,
};

export default memo(TableCell);
